import { isPlainObject } from 'lodash';
import { useMemo } from 'react';

export const useScreen = ({
  overrideCopy,
  screenMap,
  step,
}: {
  overrideCopy?: object;
  screenMap: object;
  step: { grandChild?: string; child?: string; parent: string };
}) => {
  const selection = useMemo(() => {
    const parentBlock = screenMap[step.parent];
    const parentCopy = overrideCopy?.[step.parent];

    const gChild = `${step.child}${step.grandChild ? `.${step.grandChild}` : ''}`;
    // active grandchild state with screenmap (e.g. user.microLearning.solarForAll)
    if (isPlainObject(parentBlock) && parentBlock[gChild]) {
      const copy = parentCopy?.[gChild];
      const screen = parentBlock[gChild];
      return [screen, copy];
      // active child state (e.g. enrollment.utilityConnect)
    } else if (isPlainObject(parentBlock) && parentBlock[step.child!]) {
      const copy = parentCopy?.[step.child!];
      const screen = parentBlock[step.child!];
      return [screen, copy];
      // child machine is booting up (quick temporary state)
    } else if (isPlainObject(parentBlock)) {
      const copy = undefined;
      const screen = () => null;
      return [screen, copy];
      // no child state (e.g. fetchEnrollmentOptions)
    } else {
      const copy = parentCopy;
      const screen = parentBlock;
      return [screen, copy];
    }
  }, [step]);
  return selection;
};
